export default function genererPays() {
  return {
    nom: '',
    normePTT: '',
    normeISO: '',
    actif: true,
  };
}
